
export default function SampleIssue() {
  const scrollToForm = () => {
    const element = document.getElementById('request-sample');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="see-what-youll-get" className="py-12 bg-gray-50 relative overflow-hidden">
      {/* Decorative magazine pages on left */}
      <div className="absolute left-0 top-1/3 hidden lg:block">
        <div className="w-20 h-80 bg-white rounded-r-lg shadow-lg border-r border-t border-b border-gray-200 transform -translate-x-10 rotate-3">
          <div className="h-full p-3 flex flex-col justify-between">
            <div className="space-y-1.5">
              <div className="h-2 bg-purple-100 rounded w-3/4"></div>
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-2/3"></div>
            </div>
            <div className="h-20 bg-gradient-to-br from-purple-50 to-orange-50 rounded"></div>
            <div className="space-y-1">
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-4/5"></div>
              <div className="h-1 bg-gray-100 rounded w-3/4"></div>
            </div>
          </div>
        </div>
        <div className="w-14 h-72 bg-white rounded-r-lg shadow-md border-r border-t border-b border-gray-100 transform -translate-x-12 -rotate-2 -mt-64">
          <div className="h-full p-2 flex flex-col justify-between opacity-70">
            <div className="h-1.5 bg-gray-200 rounded w-2/3"></div>
            <div className="h-14 bg-gray-100 rounded"></div>
            <div className="h-1 bg-gray-100 rounded w-full"></div>
          </div>
        </div>
      </div>

      {/* Decorative magazine pages on right */}
      <div className="absolute right-0 top-1/3 hidden lg:block">
        <div className="w-20 h-80 bg-white rounded-l-lg shadow-lg border-l border-t border-b border-gray-200 transform translate-x-10 -rotate-3">
          <div className="h-full p-3 flex flex-col justify-between">
            <div className="space-y-1.5">
              <div className="h-2 bg-purple-100 rounded w-3/4"></div>
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-2/3"></div>
            </div>
            <div className="h-20 bg-gradient-to-br from-orange-50 to-purple-50 rounded"></div>
            <div className="space-y-1">
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-4/5"></div>
              <div className="h-1 bg-gray-100 rounded w-3/4"></div>
            </div>
          </div>
        </div>
        <div className="w-14 h-72 bg-white rounded-l-lg shadow-md border-l border-t border-b border-gray-100 transform translate-x-12 rotate-2 -mt-64">
          <div className="h-full p-2 flex flex-col justify-between opacity-70">
            <div className="h-1.5 bg-gray-200 rounded w-2/3"></div>
            <div className="h-14 bg-gray-100 rounded"></div>
            <div className="h-1 bg-gray-100 rounded w-full"></div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-xs font-semibold mb-4 uppercase tracking-wide">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line text-sm"></i>
            </span>
            Preview
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            See what you&apos;ll get
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto leading-relaxed">
            A quick look at the format, local updates, and clearly labeled sponsorships.
          </p>
        </div>

        {/* Two Magazine Previews */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-6">
          {/* First Preview - From AboutSection */}
          <div className="bg-white rounded-2xl border border-gray-200 shadow-lg p-5">
            <div className="mb-3">
              <span className="inline-block px-3 py-1 bg-purple-50 text-purple-600 text-xs font-medium rounded-full">
                Sample issue preview
              </span>
            </div>
            <div className="rounded-lg overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/9de43b58d6249b351e1c65dc0206a1ae.png"
                alt="Harmony Horizon magazine preview showing cover and inside pages with local updates and sponsored content"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Second Preview - Original */}
          <div className="relative bg-white rounded-2xl shadow-lg border border-gray-200 p-5 overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 via-purple-400 to-orange-400 rounded-t-2xl"></div>
            <div className="rounded-lg overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100/50">
              <img
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/cf3e00228892ce83c0ef70df4f21dcb6.png"
                alt="Harmony Horizon magazine sample issue showing cover with spring activities, inside pages with local updates, community news, therapist features, and sponsored content sections"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>

        {/* Bottom Info Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-4 border-t border-gray-200">
          <div className="flex items-center gap-2 text-gray-500 text-sm">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-line text-purple-500"></i>
            </span>
            <span>No PHI collected. No resident lists needed. Facility reviews before distribution.</span>
          </div>
          <button
            onClick={scrollToForm}
            className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 font-medium text-sm cursor-pointer transition-colors whitespace-nowrap"
          >
            Request a pilot issue
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
